import global from "@godweb/frontend-base/src/store/global";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    global,
  },
});
export default store;
